import { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";

import { ParallelAiType } from "@/enum/parallel-ai-type.enum";

interface ParallelAiModeSelectorProps {
	mode: ParallelAiType;
	onChange: (mode: ParallelAiType) => void;
}

const MODES: { value: ParallelAiType; labelKey: string }[] = [
	{ value: ParallelAiType.SEARCH, labelKey: "modeSearch" },
	{ value: ParallelAiType.MONITOR, labelKey: "modeMonitor" },
];

export const ParallelAiModeSelector: FunctionComponent<ParallelAiModeSelectorProps> = ({
	mode,
	onChange,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`parallelAi.${key}`);

	return (
		<div className="flex flex-row gap-4 w-full flex-wrap">
			{MODES.map(({ value, labelKey }) => (
				<div key={value} className="w-auto">
					<Button
						color={mode === value ? ButtonColor.ACTION : ButtonColor.ACTION_SECONDARY}
						size={ButtonSize.ML}
						testId={`mode-${value}`}
						title={ts(labelKey)}
						onClick={() => onChange(value)}
					/>
				</div>
			))}
		</div>
	);
};
